import moment from 'moment';
import { renderSelect } from '../../components/common/formcomponents/fields';
import { CommodityMap } from 'src/types/commodity';
import { AddBidInfo } from '../../types';
import { BidExternalStatusType } from '../constants';

export const transformInstantBidData = (data: any[]) => {
  const result: any = {};
  let dueMoment: any = null;
  let broadcastMoment: any = null;

  data.forEach(item => {
    const value = item.answer;

    switch (item.key) {
      case 'is_electronic_bid':
        result.eBidding =
          value?.toLowerCase() === 'yes' ? 'yes' : 'no';
        break;

      case 'bid_number':
        result.bidNumber = value;
        break;

      case 'bid_title':
        result.bidName = value;
        break;

      case 'scope_of_work':
        result.scopeOfWork = value;
        break;

      case 'bid_description':
        result.openedText = value;
        break;

      case 'is_sealed_bid':
        result.bidBond = value;
        break;

      case 'broadcast_date':
        if (value) {
          broadcastMoment = moment(value);
          result.broadcastDate = broadcastMoment;

          const time = broadcastMoment.format('hh:mm');
          result.broadcastDateTime = {
            key: time,
            value: time,
            label: time,
            title: time,
          };

          const meridian = broadcastMoment.format('A');
          result.broadcastDateTimeZone = {
            key: meridian,
            value: meridian,
            label: meridian,
            title: meridian,
          };
        }
        break;

      case 'submission_deadline':
        if (value) {
          dueMoment = moment(value);
          result.dueDate = dueMoment;
          const time = dueMoment.format('hh:mm');
          result.dueDateTime = {
            key: time,
            value: time,
            label: time,
            title: time,
          };
          const meridian = dueMoment.format('A');
          result.dueDateTimeZone = {
            key: meridian,
            value: meridian,
            label: meridian,
            title: meridian,
          };
        }
        break;
      case 'nigp_commodity_codes':
        result.commodities = value;
        break;
      case 'related_tags':
        result.relatedtags = value;
        break;
      case 'estimated_value':
        result.projectEstimatedBudget = value;
        break;
      case 'matched_bid_type':
        const parsed = JSON.parse(value);
        result.bidType = parsed.bid_type;
        break;
      case 'matched_required_documents':
        result.reqDocIds = value;
        break;

      default:
        break;
    }
  });
  if (!broadcastMoment) {
    broadcastMoment = broadcastMoment = moment().add(24, 'hours');
    result.broadcastDate = broadcastMoment;

    broadcastMoment.set({
      hour: 11,
      minute: 0,
      second: 0,
      millisecond: 0,
    });
    const time = broadcastMoment.format('hh:mm');
    result.broadcastDateTime = {
      key: time,
      value: time,
      label: time,
      title: time,
    };

    const meridian = broadcastMoment.format('A');
    result.broadcastDateTimeZone = {
      key: meridian,
      value: meridian,
      label: meridian,
      title: meridian,
    };
  }

  return result;
};

export const formikSelectAdapter = (props: any) => {
  const { field, form, ...rest } = props;

  return renderSelect({
    ...rest,

    input: {
      name: field.name,
      value: field.value ?? null,

      onChange: (val: any) => {
        form.setFieldValue(field.name, val);
      },

      onBlur: () => {
        form.setFieldTouched(field.name, true);
      },
    },

    meta: {
      touched: form.touched[field.name],
      error: form.errors[field.name],
    },
  });
};

export const bidLabels: Record<string, string> = {
  bidBond: 'Bid Bond',
  bidNumber: 'Bid Number',
  bidName: 'Bid Name',
  bidstatus: 'Bid Status',
  broadcastDate: 'Broadcast Date',
  broadcastDateTime: 'Broadcast Time',
  dueDate: 'Due Date',
  dueTime: 'Due Time',
  bidYear: 'Fiscal Year',
  bidType: 'Bid Type',
  scopeOfWork: 'Scope of Work',
  pbcmemo: 'PBC Memo',
  openedText: 'Opened Text',
  projectEstimatedBudget: 'Project Estimated Budget',
  commodities: 'Commodity Code',
  eBidding: 'E-bidding',
  relatedtags: 'Related Tags',

};
export const findCommodityCode = (commMap: Map<string, CommodityMap>, text: string) => {
  const foundCommodities = findCommodities(Array.from(commMap.values()), text);
  return foundCommodities;
};


const normalize = (value?: string) =>
  value?.toUpperCase().replace(/[^A-Z0-9]/g, '') || '';

export const findCommodities = (comms: CommodityMap[], text: string) => {

  const searchText = normalize(text);

  return comms.filter((comm: CommodityMap) => {
    return (
      comm.commodityDescription?.toUpperCase().includes(text.toUpperCase()) ||
      normalize(comm.formattedCode).includes(searchText)
    );
  });
};

export const getCommodityQueryValue = (commodities: any, relatedTags: any): string => {
  if (commodities) {
    const entries = String(commodities)
      .split(/[;|\n]+/)
      .map(v => v.trim())
      .filter(Boolean);
    if (entries.length) {
      const first = entries[0];
      const withoutCode = first.replace(/^\d+\s*-\s*/, '');
      const extracted = withoutCode.split('(')[0].trim();
      if (extracted) return extracted;
    }
  }
  if (relatedTags) {
    const tags = String(relatedTags)
      .split(',')
      .map(v => v.trim())
      .filter(Boolean);

    if (tags.length) {
      return tags.slice(0, 2).join(', ');
    }
  }
  return '';
};
export const getStatusLabel = (status: string) => {
  if (status === 'uploading') return 'Uploading file...';
  if (status === 'pending') return 'Assigning AI agent...';
  if (status === 'processing') return 'AI is analyzing your document...';
  if (status === 'completed') return 'Completed';
  return '';
};

export const getOrderedEntries = (formData: any) => {
  const entries = Object.entries(formData).filter(
    ([key, value]) =>
      key !== 'commodities' &&
      key !== 'eBidding' &&
      key !== 'relatedtags' &&
      !key.toLowerCase().endsWith('time') &&
      !key.toLowerCase().endsWith('timezone') &&
      String(value).trim() !== '',
  );

  return [
    ...entries.filter(
      ([key]) => key !== 'broadcastDate' && key !== 'dueDate',
    ),
    ...entries.filter(([key]) => key === 'broadcastDate'),
    ...entries.filter(([key]) => key === 'dueDate'),
  ];
};

export function transformToAddBidInfo(value: any): AddBidInfo {
  const toSelectOption = (obj: any) => ({
    key: obj?.key ?? obj?.value ?? '',
    value: obj?.value ?? '',
    label: obj?.label ?? obj?.value ?? '',
  });
  const addBidInfo: AddBidInfo = {
    bidNumber: value.bidNumber ?? '',
    bidName: value.bidName ?? '',
    bidBond: value.bidBond ?? '',
    eBidding: value.eBidding === 'yes' ? 'yes' : 'no',
    openedText: value.openedText ?? '',
    scopeOfWork: value.scopeOfWork ?? '',
    dueDate: value.dueDate ?? '',
    dueTime: toSelectOption(value.dueDateTime),
    dueTimeZone: toSelectOption(value.dueDateTimeZone),

    broadcastDate: value.broadcastDate ?? '',
    broadcastDateTime: toSelectOption(value.broadcastDateTime),
    broadcastDateTimeZone: toSelectOption(value.broadcastDateTimeZone),

    bidstatus: { value: BidExternalStatusType.Upcoming, label: 'Upcoming' },
    bidYear: { value: new Date().getFullYear(), label: String(new Date().getFullYear()) },

    projectEstimatedBudget: value.projectEstimatedBudget ?? '',
    displayBudgetToSuppliers: value.displayBudgetToSuppliers ?? false,
    bidAmtRequired: value.bidAmtRequired ?? false,
    supplementalDocRequired: value.supplementalDocRequired ?? false,

    ...(value.memberId && { memberId: value.memberId }),
    ...(value.memberBidType && { memberBidType: value.memberBidType }),
    ...(value.bidWriterAccountId && { bidWriterAccountId: value.bidWriterAccountId }),
  };

  return addBidInfo;
}
